import { SAP_FAULTY_BOOKING_REPORT } from 'actions/sap';

const initialState = {
  isLoading: false,
  sapFaultyBookingReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const sapFaultyBookingReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SAP_FAULTY_BOOKING_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case SAP_FAULTY_BOOKING_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        sapFaultyBookingReport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case SAP_FAULTY_BOOKING_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default sapFaultyBookingReportReducer;
